import type { AccountInfo } from '@solana/web3.js';

const CLOCK_ACCOUNT_MINIMUM_BYTES = 40;
const CLOCK_SLOT_OFFSET = 0;
const CLOCK_UNIX_TIMESTAMP_OFFSET = 32;

export interface DecodedChainClock {
  slot: bigint;
  unixTimestampSeconds: bigint;
}

/** Decode Solana's fixed-layout Clock sysvar account. */
export function decodeChainClock(info: AccountInfo<Buffer>): DecodedChainClock {
  if (info.data.length < CLOCK_ACCOUNT_MINIMUM_BYTES) {
    throw new Error('Solana Clock sysvar account is truncated');
  }

  const data = new DataView(info.data.buffer, info.data.byteOffset, info.data.byteLength);
  const slot = data.getBigUint64(CLOCK_SLOT_OFFSET, true);
  const unixTimestampSeconds = data.getBigInt64(CLOCK_UNIX_TIMESTAMP_OFFSET, true);
  if (unixTimestampSeconds < 0n) {
    throw new Error('Solana Clock unix timestamp is negative');
  }
  return { slot, unixTimestampSeconds };
}
